import styled from "styled-components";

export const ModalBody = styled.div`
	display: flex;
	align-items: center;
	gap: 32px;
`;
